<template>
	<div>
		<v-dialog v-model="dialog_batches" v-if="dialog_batches" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="closeDialogWeb('back_icon')"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
				    <v-toolbar-title class="white--text">Add Batch</v-toolbar-title>
				</v-toolbar>
        		<!-- <v-divider></v-divider> -->
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form full-width>
						<v-layout wrap padding-top-bottom-ten white-background>
							<template v-for="(field, index) in $parent.batchFields">
							<v-flex xs6 sm6 md6 form-item :key="index" v-if="field.status">
				               <v-text-field  
					               	:label="field.title" 
                                    v-model="field.value"
					               	placeholder=" " 
					               	v-validate="'required'" 
				               		:data-vv-name="'batch_field' + index" 
                                    :data-vv-as="field.title"
				               		:error-messages="errors.collect('batch_field' + index)"
				               		required
									v-if="field.type == 'string'">
				               </v-text-field>

							   <v-text-field  
							   @click="openDatePicker(field.id, field.value)"
                                    readonly
					               	:value="field.value | moment('DD-MMM-YYYY')"
					               	:label="field.title" 
					               	placeholder=" " 
                                    append-icon="arrow_drop_down"
									v-validate="'required'" 
				               		:data-vv-name="'batch_field' + index" 
                                    :data-vv-as="field.title"
				               		:error-messages="errors.collect('batch_field' + index)"
				               		required
									v-else-if="field.type == 'date'">
				               </v-text-field>

							   <v-text-field  
					               	v-model.number="field.value"
                                    type="number"
					               	:label="field.title" 
					               	placeholder=" " 
									   v-validate="'required'" 
				               		:data-vv-name="'batch_field' + index" 
                                    :data-vv-as="field.title"
				               		:error-messages="errors.collect('batch_field' + index)"
				               		required
									v-else>
				               </v-text-field>
				            </v-flex>
							</template>
						</v-layout>
        	  			<!-- <v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	label="Batch No." 
                                    v-model="dataObj.batchNumber"
					               	placeholder=" " 
					               	v-validate="'required'" 
				               		data-vv-name="batch_number" 
                                    data-vv-as="Batch Number"
				               		:error-messages="errors.collect('fields.batch_number')"
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model="dataObj.batchSize"
					               	label="Size" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item @click="openDatePicker('mfg', dataObj.mfgDate)">
				               <v-text-field  
                                    readonly
					               	:value="dataObj.mfgDate | moment('DD-MMM-YYYY')"
					               	label="Mfg Date" 
					               	placeholder=" " 
                                    append-icon="arrow_drop_down"
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item @click="openDatePicker('exp', dataObj.mfgDate)">
				               <v-text-field  
                                    readonly
					               	:value="dataObj.expDate | moment('DD-MMM-YYYY')"
					               	label="Exp Date" 
					               	placeholder=" " 
                                    append-icon="arrow_drop_down"
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item v-if="!this.$route.query.new">
				               <v-text-field  
					               	v-model.number="dataObj.opening"
                                    type="number"
					               	label="Opening" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model.number="dataObj.batchMRP"
                                    type="number"
					               	label="MRP" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model.number="dataObj.purchaseRate"
                                    type="number"
					               	label="Purchase Rate" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model="dataObj.field1"
					               	label="Serial Number" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model="dataObj.field2"
					               	label="IMEI Number" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model="dataObj.field3"
					               	label="Part Number" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

                            <v-flex xs6 sm6 md6 form-item>
				               <v-text-field  
					               	v-model="dataObj.field4"
					               	label="Model Number" 
					               	placeholder=" " 
				               		required>
				               </v-text-field>
				            </v-flex>

						</v-layout> -->
						
        	  		</v-form>
        	  		
        	  	</v-card-text>

                <v-card-actions class="pa-0">
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6>
                            <v-btn block flat style="height: 48px;" color="primary" @click="closeDialogWeb">Cancel</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6>
                            <v-btn block style="height: 48px;" color="primary" @click="fn_attachBatch">Done</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['openDatePicker'],
	data(){	
		return{
			dialog_batches: false,
            dataObj:{
                batchId:null,
                productId:null,
                batchNumber:null,
                batchMRP:null,
                mfgDate:null,
                expDate:null,
                opening:null,
                purchaseRate:null,
                field1:null, //(serialNumber)
                field2:null, //(imeiNumber)
                field3:null, //(partNumber)
                field4:null, //(modelNumber)
                orderNumber:null,
                additionalData:null
            }
		}
	},
	methods:{
		openDialogWeb: function () {
			this.dialog_batches = true;
		},
		closeDialogWeb: function (type) {
			this.dataObj = {
                batchId:null,
                productId:null,
                batchNumber:null,
                batchMRP:null,
                mfgDate:null,
                expDate:null,
                opening:null,
                purchaseRate:null,
                field1:null, //(serialNumber)
                field2:null, //(imeiNumber)
                field3:null, //(partNumber)
                field4:null, //(modelNumber)
                orderNumber:null,
                additionalData:null
            }

			for(let i=0; i<this.$parent.batchFields.length; i++){
				this.$parent.batchFields[i].value = null;
			}

			this.dialog_batches = false;

			if(type == 'back_icon' && this.$route.query.dialog && !this.$parent.batches.length){
				this.$parent.fn_goBack();
			}
		},
        fn_attachBatch: function(){
			this.$validator.validateAll().then((result) => {
		        if (result) {
		        	 // !this.dataObj.batchId ? this.dataObj.batchId = this.guid() : '';
					for(let i=0; i<this.$parent.batchFields.length; i++){
						this.dataObj[this.$parent.batchFields[i].id] = this.$parent.batchFields[i].value;
					}

					// for(let i=0; i<this.$parent.batchFields.length; i++){
					if(!this.dataObj.batchId){
						this.dataObj.batchId = this.guid();
						this.dataObj.orderNumber = this.$parent.batches.length + 1;
						this.dataObj.isNew = true;
						// this.dataObj[this.$parent.batchFields[i].id] = this.$parent.batchFields[i].value;
						this.$parent.batches.push(JSON.parse(JSON.stringify(this.dataObj)));
					}
					else{
						let itemIndex = this.$parent.batches.findIndex(item=>{return item.batchId === this.dataObj.batchId});
						this.dataObj.isNew = false;
						// this.dataObj[this.$parent.batchFields[i].id] = this.$parent.batchFields[i].value;
						let tempItem = JSON.parse(JSON.stringify(this.dataObj));
						this.$parent.batches.splice(itemIndex, 1);
						this.$parent.batches.splice(itemIndex, 0, tempItem);
						this.$forceUpdate();
					}
					// }

					// if(!this.dataObj.batchId){
					// 	this.dataObj.batchId = this.guid();
					// 	this.dataObj.orderNumber = this.$parent.batches.length + 1;
					// 	this.dataObj.isNew = true;
					// 	this.$parent.batches.push(JSON.parse(JSON.stringify(this.dataObj)));
					// }
					// else{
					// 	let itemIndex = this.$parent.batches.findIndex(item=>{return item.batchId === this.dataObj.batchId});
					// 	// this.$parent.batches[itemIndex] = JSON.parse(JSON.stringify(this.dataObj));
					// 	this.dataObj.isNew = false;
					// 	let tempItem = JSON.parse(JSON.stringify(this.dataObj));
					// 	this.$parent.batches.splice(itemIndex, 1);
					// 	this.$parent.batches.splice(itemIndex, 0, tempItem);
					// 	this.$forceUpdate();
					// }
					// this.dataObj.orderNumber = this.$parent.batches.length + 1;
					// this.$parent.batches.push(JSON.parse(JSON.stringify(this.dataObj)));
					this.closeDialogWeb();
		        }
		    });
           
        },
		// fn_checkValidations: function(){
		// 	this.$validator.validateAll('fields').then((result) => {
		//         if (result) {
		//         	this.saveAddOns(this.$parent.Form.addOnsDataModel);
		//         }
		//     });
		// },
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/product_batches/dialog_form.vue